import { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../../routes/coach";
import { fetchBootCamps } from "../../../redux/features/coach/actions/authAction";
import BootcampPurchaseModal from "../../../components/Modals/purchaseModal/bootcampPurchaseModal";
import WaittingListBootCamp from "../../../components/Modals/purchaseModal/WaittingListBootCamp";
import BootCampLayout from "../../../layouts/BootCampLayout";
import PaymentModal from "../../../components/Modals/common/webinar/PaymentModal";
import MenuLayout from "../../../layouts/MenuLayout";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const BootcampList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoading, bootcampList } = useSelector(
        (state) => state?.coach?.auth
    );

    const [isPurchse, setIsPurchase] = useState(false);
    const [isWaitList, setIsWaitList] = useState(false);
    const [bootCampId, setBootCampId] = useState("");

    const [isPaymentShow, setIsPaymentShow] = useState(false);

    const user = { name: "bootcamp", role: "coach" };

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        margin: 20,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    useEffect(() => {
        dispatch(fetchBootCamps());
    }, []);

    const handleModalOpen = (item) => {
        setBootCampId(item?.bootcamp_id);
        if (item?.available_seats == 0) {
            setIsWaitList(true);
        } else {
            setIsPurchase(true);
        };
    };

    if (isLoading) {
        return <Loader />;
    };
    return (
        <MenuLayout user={user}>
            <section class="ct_px_40 ct_pb_100 pt-5 pe-0">
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <div
                            class="col-xxl-5 col-xl-5 col-md-5 mb-4 mb-md-0"
                            data-aos="fade-right"
                            data-aos-duration="1500"
                        >
                            <div class="ct_boocamp_img_left">
                                <img
                                    src="assets/img/booscamp_left_img.png"
                                    alt=""
                                    class="ct_img_h_442 w-100 ct_border_radius_32"
                                />
                            </div>
                        </div>
                        <div
                            class="col-xxl-7 col-xl-7 col-md-7 mb-4 mb-md-0"
                            data-aos="fade-left"
                            data-aos-duration="1500"
                        >
                            <div class="ps-4 ct_px_0_767">
                                <h2 class="ct_fs_50 mb-2" style={{ maxWidth: "700px" }}>
                                    NUVIO’S Signature{" "}
                                    <span class="ct_yellow_text">BOOTCAMPS :</span>
                                    <span class="ct_fs_32 ct_darksky_blue_text">
                                        {" "}
                                        Where Ideas Take Flight
                                    </span>
                                </h2>

                                <p class="mb-0 mt-3 ct_fs_20" style={{ maxWidth: "594px" }}>
                                    A transformative space where ambitious professionals connect,
                                    collaborate, and grow. Gain insights, strategies, and a
                                    powerful network to unlock your true potential.
                                </p>
                                <div class="mt-4">
                                    <a
                                        class="ct_yellow_btn ct_orange_bg px-5 ct_fit_content ct_h_48"
                                        onClick={() => {
                                            const section = document.getElementById(
                                                "ct_choose_bootcamp_plan"
                                            );
                                            section?.scrollIntoView({ behavior: "smooth" });
                                        }}
                                    >
                                        Take your seat
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div>
                <h2
                    class="ct_fs_70 ct_darksky_blue_text text-center mx-auto"
                    style={{ maxWidth: "816px" }}
                >
                    We design unforgettable moments for you :
                </h2>
                <section class="ct_light_orange_bg12 ct_mt_32">
                    <div class="container">
                        <div class="row ">
                            <div
                                class="col-md-4 col-sm-6 ct_mb_90"
                                data-aos="fade-right"
                                data-aos-duration="1500"
                            >
                                <div class="ct_content_sale_card">
                                    <div
                                        class="ct_content_sale_card_icon"
                                        style={{ backgroundColor: "hsl(32deg 100% 49% / 30%)" }}
                                    >
                                        <img
                                            src="assets/img/globel_connection.png"
                                            alt=""
                                            style={{ objectFit: "contain", width: "auto" }}
                                        />
                                    </div>
                                    <h4 class="mb-0  ct_fs_32  mt-3">
                                        Global <br /> Connection
                                    </h4>
                                </div>
                            </div>
                            <div
                                class="col-md-4 col-sm-6 ct_mb_90"
                                data-aos="fade-down"
                                data-aos-duration="1500"
                            >
                                <div class="ct_content_sale_card">
                                    <div
                                        class="ct_content_sale_card_icon"
                                        style={{ backgroundColor: "#D9D9D9" }}
                                    >
                                        <img
                                            src="assets/img/Entrepreneurial_Growth.png"
                                            alt=""
                                            style={{ objectFit: "contain", width: "auto" }}
                                        />
                                    </div>
                                    <h4 class="mb-0  ct_fs_32  mt-3">
                                        Entrepreneurial <br /> Growth
                                    </h4>
                                </div>
                            </div>
                            <div
                                class="col-md-4 col-sm-6 ct_mb_90"
                                data-aos="fade-left"
                                data-aos-duration="1500"
                            >
                                <div class="ct_content_sale_card">
                                    <div
                                        class="ct_content_sale_card_icon"
                                        style={{ backgroundColor: "hsl(43deg 100% 51% / 30%)" }}
                                    >
                                        <img
                                            src="assets/img/Innovation_&_Creativity.png"
                                            alt=""
                                            style={{ objectFit: "contain", width: "auto" }}
                                        />
                                    </div>
                                    <h4 class="mb-0  ct_fs_32  mt-3">
                                        Innovation <br /> & Creativity
                                    </h4>
                                </div>
                            </div>
                            <div
                                class="col-md-4 col-sm-6 ct_mb_90"
                                data-aos="fade-right"
                                data-aos-duration="1500"
                            >
                                <div class="ct_content_sale_card">
                                    <div
                                        class="ct_content_sale_card_icon"
                                        style={{ backgroundColor: "rgb(142 202 230 / 50%)" }}
                                    >
                                        <img
                                            src="assets/img/Holistic_Transformation.png"
                                            alt=""
                                            style={{ objectFit: "contain", width: "auto" }}
                                        />
                                    </div>
                                    <h4 class="mb-0  ct_fs_32  mt-3">
                                        Holistic <br /> Transformation
                                    </h4>
                                </div>
                            </div>
                            <div
                                class="col-md-4 col-sm-6 ct_mb_90"
                                data-aos="fade-down"
                                data-aos-duration="1500"
                            >
                                <div class="ct_content_sale_card">
                                    <div
                                        class="ct_content_sale_card_icon"
                                        style={{ backgroundColor: "#fff" }}
                                    >
                                        <img
                                            src="assets/img/Collaboration_&_Community.png"
                                            style={{ objectFit: "contain", width: "auto" }}
                                            alt=""
                                        />
                                    </div>
                                    <h4 class="mb-0  ct_fs_32  mt-3">
                                        Collaboration <br /> & Community
                                    </h4>
                                </div>
                            </div>
                            <div
                                class="col-md-4 col-sm-6 ct_mb_90"
                                data-aos="fade-left"
                                data-aos-duration="1500"
                            >
                                <div class="ct_content_sale_card">
                                    <div
                                        class="ct_content_sale_card_icon"
                                        style={{ backgroundColor: "#023047" }}
                                    >
                                        <img
                                            src="assets/img/Empowerment.png"
                                            alt=""
                                            style={{ objectFit: "contain", width: "auto" }}
                                        />
                                    </div>
                                    <h4 class="mb-0  ct_fs_32  mt-3">Empowerment</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {bootcampList?.length > 0 && (
                <section class="ct_py_100  ct_px_40">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <h2 class="ct_fs_50 ct_fw_600 text-center ct_darksky_blue_text ct_mb_182">
                                    NUVIO Signature{" "}
                                    <span class="ct_yellow_text ct_fw_400">Bootcamps </span>
                                </h2>
                                <div class="ct_timeline_main">
                                    <ul>
                                        {bootcampList?.map((item, index) => {
                                            const formattedDate = `${moment(item?.start_date).format(
                                                "DD MMM YYYY"
                                            )} - ${moment(item?.end_date).format("DD MMM YYYY")}`;
                                            return (
                                                <>
                                                    <li data-aos="fade-down" data-aos-duration="1500">
                                                        {index % 2 == 0 ? (
                                                            <>
                                                                <div
                                                                    onClick={() => {
                                                                        navigate(`/bootcamp-detail/${item?.bootcamp_id}`, {
                                                                            state: { id: item?.bootcamp_id, data2: "landing", data: bootcampList },
                                                                        });
                                                                    }}
                                                                    class="ct_cursor_pointer ct_timeline_img_left ct_light_blue_after_clr ct_img_h_338 w-100 position-relative"
                                                                >
                                                                    <img
                                                                        src={item?.brochure || ""}
                                                                        alt=""
                                                                        class=""
                                                                    />
                                                                    <div class="ct_bootcamp_overlay_text">
                                                                        <h4 class="ct_fs_18 ct_para_scroll ct_custom_scroll">
                                                                            <span class="ct_orange_text">
                                                                                {item?.header_title || ""} -
                                                                            </span>{" "}
                                                                            <span class="ct_text_clr_8ECAE6 ct_fs_14">
                                                                                {item?.header_sub_title || ""}
                                                                            </span>{" "}
                                                                        </h4>
                                                                        <ul class="d-flex align-items-center gap-0 gap-sm-5 mt-0 pt-2">
                                                                            <li class="ct_fs_14  d-flex align-items-center gap-3 text-white">
                                                                                <img
                                                                                    src="assets/img/light_blue_clock.png"
                                                                                    alt=""
                                                                                />{" "}
                                                                                {formattedDate}
                                                                            </li>
                                                                            <li class="ct_fs_14 d-flex align-items-center gap-3 text-white">
                                                                                {" "}
                                                                                <img
                                                                                    src="assets/img/light_blue_location.png"
                                                                                    alt=""
                                                                                />{" "}
                                                                                {item?.location || ""}
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                    <div class="ct_boocamp_info_on_hover px-3" style={{ backgroundColor: item?.brochure_color || "#1e4457" }}>
                                                                        <p class="mb-0 ct_fs_15 ct_para_scroll text-center ct_custom_scroll ">
                                                                            {item?.header_description || ""}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="ct_timeline_right ct_timeline_right_dot    w-100">
                                                                    <p class="mb-0 d-flex align-items-center gap-2">
                                                                        <img
                                                                            src="assets/img/calender_icon.png"
                                                                            alt=""
                                                                            class="ct_icon_30"
                                                                        />
                                                                        {formattedDate}
                                                                    </p>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div class="ct_timeline_right ct_timeline_left_dot   w-100">
                                                                    <p class="mb-0 d-flex align-items-center gap-2 justify-content-end">
                                                                        <img
                                                                            src="assets/img/calender_icon.png"
                                                                            alt=""
                                                                            class="ct_icon_30"
                                                                        />
                                                                        {formattedDate}
                                                                    </p>
                                                                </div>
                                                                <div onClick={() => { navigate(`/bootcamp-detail/${item?.bootcamp_id}`, { state: { id: item?.bootcamp_id, data2: "landing", data: bootcampList } }) }} class="ct_timeline_img_left ct_cursor_pointer ct_light_blue_after_clr ct_img_h_338 w-100 position-relative">
                                                                    <img
                                                                        src={item?.brochure || ""}
                                                                        alt=""
                                                                        class=""
                                                                    />
                                                                    <div class="ct_bootcamp_overlay_text">
                                                                        <h4 class="ct_fs_18 ct_para_scroll ct_custom_scroll" style={{ maxHeight: "156px" }}>
                                                                            <span class="ct_orange_text">
                                                                                {item?.header_title || ""} -
                                                                            </span>{" "}
                                                                            <span class="ct_text_clr_8ECAE6 ct_fs_14">
                                                                                {item?.header_sub_title || ""}
                                                                            </span>{" "}
                                                                        </h4>
                                                                        <ul class="d-flex align-items-center gap-0 gap-sm-5 mt-0 pt-2">
                                                                            <li class="ct_fs_14  d-flex align-items-center gap-3 text-white">
                                                                                <img
                                                                                    src="assets/img/light_blue_clock.png"
                                                                                    alt=""
                                                                                />{" "}
                                                                                {formattedDate}
                                                                            </li>
                                                                            <li class="ct_fs_14 d-flex align-items-center gap-3 text-white">
                                                                                {" "}
                                                                                <img
                                                                                    src="assets/img/light_blue_location.png"
                                                                                    alt=""
                                                                                />{" "}
                                                                                {item?.location || ""}
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                    <div class="ct_boocamp_info_on_hover  px-3" style={{ backgroundColor: item?.brochure_color || "#1e4457" }}>
                                                                        <p class="mb-0 ct_fs_15 ct_para_scroll text-center ct_custom_scroll">
                                                                            {item?.header_description || ""}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </li>
                                                </>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
            <section
                class="ct_looking_for_work_bg mt-5"
                style={{ backgroundColor: "var(--yellow)" }}
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                    <div class="">
                        <h4 class="ct_fs_36 text-white">
                            Learn. Connect. Scale, all in one Session
                        </h4>
                        <p class="mb-0 ct_fs_20" style={{ maxWidth: "657px" }}>
                            Each session is designed to help you learn from experts, connect
                            with driven professionals, and gain the tools to scale your career
                            or business with clarity and confidence.
                        </p>
                    </div>
                    <div class="ct_flex_shrink_0">
                        <a
                            // href="javascript:void(0)"
                            // data-bs-target="#ct_waitlist_modal"
                            // data-bs-toggle="modal"
                            class="ct_yellow_btn ct_sky_blue_btn ct_flex_1 px-5"
                        >
                            Our events
                        </a>
                    </div>
                </div>
            </section>

            <section class="ct_sky_blue_bg ct_py_100 ct_mt_66 ct_px_109 ">
                <div class="container-fluid">
                    <div class="row align-items-center">
                        <div class="col-lg-4 mb-4 mb-lg-0">
                            <div class="ct_img_unlock_img_23">
                                <div class="ct_img_unlock_img_23_left">
                                    <img src="assets/img/bootcamp_img_901.jpg" alt="" style={{ objectPosition: "top" }} />
                                    <img src="assets/img/ready_unlock_img_2.jpg" alt="" style={{ objectPosition: "top" }} />
                                </div>
                                <div class="ct_img_unlock_img_23_right">
                                    <img src="assets/img/ready_unlock_img_3.png" alt="" style={{ objectPosition: "top" }} />
                                    <img src="assets/img/bootcamp_img_905.jpg" alt="" style={{ objectPosition: "top" }} />
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-8 mb-4 mb-lg-0 ps-lg-5">
                            <h4 class="ct_fs_36 ct_orange_text ct_mb_30">
                                Ready to unlock the next level of your growth?
                            </h4>
                            <p class="ct_fs_20 ct_mb_30" style={{ maxWidth: "713px" }}>
                                In today’s fast-moving world, standing still isn’t an option. Whether you’re refining your technical edge, shaping bold ideas, or redefining how you lead growth requires clarity, strategy, and the right environment to thrive.
                            </p>
                            <p class="ct_fs_20 ct_mb_30" style={{ maxWidth: "713px" }}>
                                NUVIO Bootcamps are built to help you do just that. Each experience blends hands-on learning, collaboration, and self-discovery to help you bridge the gap between where you are and where you want to be.{" "}
                            </p>
                            <p class="ct_fs_20 ct_mb_30" style={{ maxWidth: "713px" }}>
                                These bootcamps aren’t just about learning new skills, they’re about transformation. You’ll gain the mindset, confidence, and network to turn knowledge into action and action into results. From mastering technology to elevating your leadership, from freelancing smarter to empowering your business journey.
                            </p>
                            <p class="ct_fs_20" style={{ maxWidth: "713px" }}>
                                NUVIO Bootcamps equip you with tools that move you forward with focus, purpose, and momentum.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {bootcampList?.length > 0 && (
                <section class="ct_pt_100 ct_px_75" id="ct_choose_bootcamp_plan">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <h2 class="ct_fs_48 text-center ct_pb_100">
                                    Choose the Right{" "}
                                    <span class="ct_darksky_blue_text">Bootcamp</span> For You
                                </h2>
                            </div>
                        </div>
                        <Swiper
                            // {...settings}
                            modules={[Navigation]}
                            navigation={true}
                            // spaceBetween={20}
                            slidesPerView={3}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                                700: {
                                    slidesPerView: 2,
                                },
                                1199: {
                                    slidesPerView: 3,
                                },
                            }}
                        >
                            {bootcampList?.map((item, index) => {
                                const start = moment(item?.start_date);
                                const end = moment(item?.end_date);
                                const diffDays = end.diff(start, "days") + 1;
                                const formatted = `${diffDays} days bootcamp`;
                                return (
                                    <SwiperSlide key={index}>
                                        <div class="ct_choose_right_bootcamp_card">
                                            <figure
                                                class="mb-0 ct_cursor_pointer"
                                                onClick={() => { navigate(`/bootcamp-detail/${item?.bootcamp_id}`, { state: { id: item?.bootcamp_id, data2: "landing", data: bootcampList } }) }}
                                            >
                                                <div class="ct_choose_right_boot_img position-relative">
                                                    <img src={item?.brochure || ""} alt="" />
                                                    <div class="ct_right_boot_overlay_text">
                                                        <p class="ct_fS_18 ct_orange_text mb-0">
                                                            {item?.header_title || ""}{" "}
                                                        </p>
                                                        <h2 class="ct_fs_45 text-white mb-0">
                                                            Rs {item?.price ?? 0}{" "}
                                                        </h2>
                                                        <small class="ct_fs_14 text-white">
                                                            {formatted}
                                                        </small>
                                                    </div>
                                                </div>
                                                <figcaption>
                                                    <p
                                                        class="ct_fs_20 ct_darksky_blue_text ct_para_scroll ct_custom_scroll ct_h_60"
                                                        style={{ maxWidth: "380px" }}
                                                    >
                                                        {item?.header_sub_title || ""}
                                                    </p>
                                                    <ul className="pt-0">
                                                        {item?.points?.map((obj) => {
                                                            return (
                                                                <li>
                                                                    <img
                                                                        src="assets/img/emojione_white-heavy-check-mark.png"
                                                                        alt=""
                                                                    />
                                                                    <span>{obj}</span>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </figcaption>
                                            </figure>
                                            <div class="mt-auto" style={{ padding: "0px 17px 20px" }}>
                                                <p class="ct_fs_14 mb-4 ct_darksky_blue_text">
                                                    Only {item?.available_seats ?? 0} seats left
                                                </p>
                                                <a
                                                    class="ct_yellow_btn ct_orange_bg ct_h_44"
                                                    onClick={() => {
                                                        // setIsPurchase(true);
                                                        handleModalOpen(item);
                                                        // setIsWaitList(true);
                                                        // setBootCampId(item?.bootcamp_id);
                                                    }}
                                                >
                                                    Purchase
                                                </a>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                            {/* {bootcampList?.map((item, index) => {
                                const start = moment(item?.start_date);
                                const end = moment(item?.end_date);
                                const diffDays = end.diff(start, "days") + 1;
                                const formatted = `${diffDays} days bootcamp`;
                                return (
                                    <div class="ct_choose_right_bootcamp_card">
                                        <figure class="mb-0 ct_cursor_pointer" onClick={() => { navigate(`/bootcamp-detail/${item?.bootcamp_id}`, { state: { id: item?.bootcamp_id, data2: "landing", data: bootcampList } }) }}>
                                            <div class="ct_choose_right_boot_img position-relative">
                                                <img src={item?.brochure || ""} alt="" />
                                                <div class="ct_right_boot_overlay_text">
                                                    <p class="ct_fS_18 ct_orange_text mb-0">
                                                        {item?.header_title || ""}{" "}
                                                    </p>
                                                    <h2 class="ct_fs_45 text-white mb-0">
                                                        Rs {item?.price ?? 0}{" "}
                                                    </h2>
                                                    <small class="ct_fs_14 text-white">{formatted}</small>
                                                </div>
                                            </div>
                                            <figcaption>
                                                <p
                                                    class="ct_fs_20 ct_darksky_blue_text ct_para_scroll ct_custom_scroll ct_h_60"
                                                    style={{ maxWidth: "380px" }}
                                                >
                                                    {item?.header_sub_title || ""}
                                                </p>
                                                <ul className="pt-0">
                                                    {item?.points?.map((obj) => {
                                                        return (
                                                            <li>
                                                                <img
                                                                    src="assets/img/emojione_white-heavy-check-mark.png"
                                                                    alt=""
                                                                />
                                                                <span>{obj}</span>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>

                                            </figcaption>
                                        </figure>
                                        <div class="mt-auto" style={{ padding: "0px 17px 20px" }}>
                                            <p class="ct_fs_14 mb-4 ct_darksky_blue_text">
                                                Only {item?.available_seats ?? 0} seats left
                                            </p>
                                            <a class="ct_yellow_btn ct_orange_bg ct_h_44"
                                                onClick={() => {
                                                    handleModalOpen(item);
                                                }}
                                            >
                                                Purchase
                                            </a>
                                        </div>
                                    </div>
                                );
                            })} */}
                        </Swiper>
                    </div>
                </section>
            )}

            <section
                class="ct_looking_for_work_bg ct_mt_100 ct_looking_for_work_bg_left ct_orange_bg"
                data-aos="fade-right"
                data-aos-duration="1500"
            >
                <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                    <div class="text-white">
                        <h4 class="ct_fs_36 mb-3" style={{ maxWidth: "639px" }}>
                            Ready to Learn Something That Actually Moves the Needle?
                        </h4>
                        <p class="mb-0 ct_fs_18" style={{ maxWidth: "621px" }}>
                            Join a live session, get real-time support, and walk away with
                            tools you can apply today- not someday.{" "}
                        </p>
                    </div>
                    <div class="ct_flex_shrink_0">
                        <a
                            class="ct_yellow_btn ct_darkblue_btn ct_flex_1"
                        // data-bs-target="#ct_waitlist_modal"
                        // data-bs-toggle="modal"
                        >
                            Explore Our Services
                        </a>
                    </div>
                </div>
            </section>

            {isPurchse && bootCampId &&
                <BootcampPurchaseModal
                    onClose={() => setIsPurchase(false)}
                    ID={bootCampId}
                    handleClose={() => {
                        setIsPurchase(false);
                        dispatch(fetchBootCamps());
                        setIsPaymentShow(true);
                    }}
                />
            }
            {isPaymentShow &&
                <PaymentModal
                    onClose={() => setIsPaymentShow(false)}
                />
            }
            {isWaitList &&
                <WaittingListBootCamp
                    onClose={() => setIsWaitList(false)}
                    ID={bootCampId}
                    handleClose={() => {
                        setIsWaitList(false);
                        dispatch(fetchBootCamps());
                    }}
                />

            }

                  <div style={{height:"100px"}}></div>
        </MenuLayout>
    );
};

export default BootcampList;